import { PROCESS } from "@/data/content";
import { motion } from "framer-motion";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#080808] py-24 md:py-32 px-6 md:px-12 lg:px-24 border-t border-white/10 overflow-hidden"
    >
      {/* Kinetic outline bg text */}
      <div className="pointer-events-none absolute inset-x-0 top-10 text-center select-none">
        <span className="font-display uppercase text-[18vw] leading-none text-outline whitespace-nowrap">
          The Process
        </span>
      </div>

      <div className="relative max-w-4xl mb-16 md:mb-24">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E50914] mb-6">
          // 04 — How we build
        </p>
        <h2
          data-testid="process-title"
          className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9]"
        >
          From treatment <br /> to delivery.
        </h2>
      </div>

      <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {PROCESS.map((p, i) => (
          <motion.div
            key={p.step}
            data-testid={`process-step-${p.step}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="bg-[#0a0a0a] p-7 md:p-9 flex flex-col"
          >
            <div className="font-display uppercase text-[#E50914] text-6xl leading-none mb-6">
              {p.step}
            </div>
            <h3 className="font-display uppercase text-white text-2xl md:text-3xl leading-none mb-4">
              {p.title}
            </h3>
            <p className="text-zinc-400 text-sm md:text-base leading-relaxed">
              {p.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
